import { FormBuilder } from '../../modules/formBuilder'
import { KycInfo } from '../../modules/kycInfo'
import { LoadingScreen } from '../../modules/loadingScreen'
import Otp from '../../modules/otp'
import Review from '../../modules/review'
import { StatusScreen } from '../../modules/statusScreen'

export const axisStateMap = {
  CC_START: {
    Component: LoadingScreen,
    props: {
      subTitle:
        'Please wait while we are checking your eligibility with Axis Bank',
    },
  },
  CC_BASIC_DETAILS: {
    Component: FormBuilder,
  },
  CC_ADDRESS_DETAILS: {
    Component: FormBuilder,
  },
  CC_EMP_DETAILS: {
    Component: FormBuilder,
  },
  CC_CONFIRMATION: {
    Component: FormBuilder,
  },
  CC_REVIEW: {
    Component: Review,
  },
  CC_OTP_SUBMIT: {
    Component: Otp,
  },
  CC_SUBMIT_PROGRESS: {
    Component: LoadingScreen,
    props: {
      subTitle:
        'Please wait while we are checking your eligibility with Axis Bank',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 150,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Still Processing...',
          subTitle:
            "We're still waiting on the final confirmation from Axis Bank. We will notify you as soon as we have a response.",
          image: 'CLOCK_ARROW_BLUE',
        },
        note: {
          position: 'top',
          icon: 'ClockOutlined',
          text: 'This may take up to 48 hours. You will be notified once updated status is received from Axis Bank.',
          type: 'error',
        },
      },
    },
  },
  CC_KYC_OFFLINE: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Application Submitted, Verification Required!',
        subTitle:
          'Axis Bank executive will contact you for completion of KYC and Verification. You can reach out to Axis Bank Customer Care at 1860 419 5555',
        image: 'SUCCESS',
      },
      showC1Id: true,
    },
  },
  CC_APPLICATION_UNDER_REVIEW: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'KYC Complete,\nApplication Under Review!',
        subTitle:
          'Your application is under review with Axis Bank Credit Cards team. You will be notified once it is reviewed. You can reach out to Axis Bank Customer Care at 1860 419 5555',
        image: 'DOCUMENT_SEARCH',
      },
      showC1Id: true,
    },
  },
  CC_APPLICATION_SUCCESS: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Congratulation, Card Approved!',
        subTitle:
          'Congratulations, your Axis Bank Credit Card has been approved. Your card will be dispatched soon. Check your SMS for the status of card delivery.',
        image: 'CARDS_SUCCESS',
      },
    },
  },
  CC_SUBMIT_SUCCESS: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Application Submitted, KYC Required!',
        subTitle:
          'Congratulations! Your credit card application is in-principle approved by Axis Bank. Please proceed with the KYC verification to complete your application',
        image: 'SUCCESS',
      },
      note: {
        position: 'bottom',
        localizationText: 'axis.note.onlineKycWindowWillExpire',
      },
      buttons: [
        {
          icon: 'CameraFilled',
          title: 'Start Kyc',
          action: 'STATE_MACHINE_POST',
        },
        {
          type: 'outlined',
          icon: 'Share',
          title: 'Share KYC Link',
          action: 'KYC_SHARE_LINK',
        },
      ],
    },
  },
  CC_INCORRECT_DETAILS: {
    Component: StatusScreen,
    props: {
      status: {
        title: "Oops, Something's Not Right",
        subTitle: 'Following information in your form seems incorrect:',
        image: 'INCORRECT_DETAILS',
      },
      note: {
        position: 'bottom',
        localizationText: 'axis.note.editFormDetails',
      },
      buttons: [
        {
          title: 'Edit Application',
          action: 'STATE_MACHINE_POST',
        },
      ],
    },
  },
  CC_REJECTED: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oh No, Application Rejected!',
        subTitle:
          "We're sorry, but you do not meet the criteria required by Axis Bank at the moment. Please try again after 3 months.",
        image: 'DOCUMENT_CROSS',
      },
      showC1Id: true,
    },
  },
  CC_AXIS_SERVER_ERROR: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oops, Something Went Wrong!',
        subTitle:
          "We're currently unable to process this request due to a technical issue. Please try again.",
        image: 'SERVER_ERROR',
      },
      buttons: [
        {
          title: 'Try Again',
          action: 'STATE_MACHINE_POST',
        },
      ],
    },
  },
  CC_KYC_PENDING: {
    Component: KycInfo,
    props: {
      title: 'One Step Away',
      subTitle:
        'Hey!  You are just one step away from completing your application for Axis Bank Credit Card. Complete following steps to get your Axis Bank Credit Card👇',
      steps: [
        {
          title: 'E- KYC',
          subTitle: 'OTP Verification',
          show: ['STPT', 'STPK'],
        },
        {
          title: 'Video KYC',
          subTitle: 'Please keep your Camera on while V- KYC',
          show: ['STPT', 'STPK'],
        },
        {
          title: 'Income Verfication',
          subTitle: 'Need to Submit Income Proof',
          show: ['STPT'],
        },
      ],
      buttons: [
        {
          icon: 'AssignedFilled',
          title: 'Start KYC',
          action: 'STATE_MACHINE_POST',
        },
        {
          icon: 'Share',
          title: 'Share Link',
          action: 'KYC_SHARE_LINK',
          type: 'outlined',
        },
      ],
    },
  },
  CC_KYC_START: {
    Component: KycInfo,
    props: {
      heading: 'One Step Away',
      subTitle:
        'Hey!  You are just one step away from completing your application for Axis Bank Credit Card. Complete following steps to get your Axis Bank Credit Card👇',
      steps: [
        {
          title: 'E- KYC',
          subTitle: 'OTP Verification',
          show: ['STPT', 'STPK'],
        },
        {
          title: 'Video KYC',
          subTitle: 'Please keep your Camera on while V- KYC',
          show: ['STPT', 'STPK'],
        },
        {
          title: 'Income Verfication',
          subTitle: 'Need to Submit Income Proof',
          show: ['STPT'],
        },
      ],
      note: {
        position: 'bottom',
        localizationText: 'axis.note.onlineKycWindowWillExpire',
      },
      buttons: [
        {
          icon: '',
          title: 'Redirecting you to Axis Bank',
          action: 'STATE_MACHINE_POST',
        },
      ],
    },
  },
  CC_KYC_PENDING_B: {
    Component: KycInfo,
    props: {
      title: 'One Step Away',
      subTitle:
        'Hey!  You are just one step away from completing your application for Axis Bank Credit Card. Complete following steps to get your Axis Bank Credit Card👇',
      steps: [
        {
          title: 'E- KYC',
          subTitle: 'OTP Verification',
          show: ['STPT', 'STPK'],
        },
        {
          title: 'Video KYC',
          subTitle: 'Please keep your Camera on while V- KYC',
          show: ['STPT', 'STPK'],
        },
        {
          title: 'Income Verfication',
          subTitle: 'Need to Submit Income Proof',
          show: ['STPT'],
        },
      ],
      buttons: [
        {
          icon: 'AssignedFilled',
          title: 'Start KYC',
          action: 'STATE_MACHINE_POST',
        },
        {
          icon: 'Share',
          title: 'Share Link',
          action: 'KYC_SHARE_LINK',
          type: 'outlined',
        },
      ],
    },
  },
  CC_KYC_END_STATUS: {
    Component: StatusScreen,
  },
  CC_KYC_STATUS: {
    Component: StatusScreen,
  },
  CC_KYC_LANDING: {
    Component: LoadingScreen,
    props: {
      subTitle:
        'Please wait while we are checking your eligibility with Axis Bank',
    },
  },
  CC_SUBMIT_TIMEOUT: {
    Component: StatusScreen,
    props: {
      status: {
        image: 'CLOCK_ARROW_BLUE',
        title: 'Still Processing...',
        subTitle:
          "We're still waiting on the final confirmation from Axis Bank. We will notify you as soon as we have a response.",
      },
      note: {
        position: 'top',
        localizationText: 'axis.note.onlineKycWindowWillExpireProcessing',
        type: 'error',
      },
    },
  },
}
